import EmployeeLayout from '../components/EmployeeLayout';
import TeamChat from '../../components/chat/TeamChat';

// Team chat for staff who don't have the cockpit.
//
// The same component the org-admin Chat page renders under its "Team" tab —
// there is one implementation, and this route exists only because the cockpit
// page sits behind `nav.clients`, which an employee has no reason to hold.
// Client conversations are deliberately NOT here: an employee reaches those
// through the cockpit page if an admin has granted them Clients.
function EmployeeChat() {
  return (
    <EmployeeLayout title="Team Chat" subtitle="Message anyone in your firm">
      <TeamChat />
    </EmployeeLayout>
  );
}

export default EmployeeChat;
